import React from 'react';
import { Box } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { RichTextArea, TextArea } from '@travelity/form';

export interface ProductPoliciesFormProps {
    preview?: boolean;
    showErrors?: boolean;
}

const ProductPoliciesForm: React.FC<ProductPoliciesFormProps> = ({
    preview,
    showErrors,
}) => {
    const { t } = useTranslation('product');
    const { watch } = useFormContext();

    return (
        <Box sx={{ width: '100%' }}>
            {preview ? (
                <Box sx={{ width: '100%' }}>
                    {!watch('policyText') && t('No policies defined')}
                    {watch('policyText') && (
                        <Box
                            dangerouslySetInnerHTML={{
                                __html: watch('policyText'),
                            }}
                        />
                    )}
                </Box>
            ) : (
                <RichTextArea
                    placeholder={t('Type Cancellation Policy')}
                    name="policyText"
                    showErrors={showErrors}
                    hideHelperText
                    label={t('Cancellation Policy')}
                    required
                    sx={{
                        width: '100%',
                        minHeight: '200px',
                    }}
                />
            )}
        </Box>
    );
};

export default React.memo(ProductPoliciesForm);
